export const deliveredChecked = (data: number) => {
  if (data === 1) { return "Pending" }
  if (data === 2) { return "Part Delivered" }
  if (data === 3) { return "Full Delivered" }
  return "-"
}